/* BBI mobile sections: bottom nav actions, card variant picker, countdown, coupon copy.
   Tabs reuse the theme's generic [data-tabs] handler in bbi.js. */
(() => {
  /* Bottom nav: Menu opens the header's slide-out menu; Search opens the header search field */
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('[data-mnav-menu]');
    if (menu) {
      const toggle = document.querySelector('[data-menu-toggle]');
      if (toggle) {
        event.preventDefault();
        toggle.click();
      }
      return;
    }

    const search = event.target.closest('[data-mnav-search]');
    if (search) {
      const toggle = document.querySelector('.hdr-search-toggle');
      const input = document.querySelector('[data-search-input]');
      if (!toggle || !input) return;
      event.preventDefault();
      window.scrollTo({ top: 0 });
      const header = toggle.closest('.hdr');
      if (header && !header.classList.contains('hdr--search-open')) {
        toggle.click();
      } else {
        input.focus();
      }
    }
  });

  /* Cart count badges: hide when the cart is empty (cart.js updates the number) */
  const syncBadges = () => {
    document.querySelectorAll('[data-mnav-count]').forEach((el) => {
      const value = el.textContent.trim();
      el.hidden = value === '' || value === '0';
    });
  };
  document.querySelectorAll('[data-mnav-count]').forEach((el) => {
    new MutationObserver(syncBadges).observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* Product card size/flavour picker: update price, MRP, % off, unit price and savings for the chosen option */
  const setText = (el, value) => {
    if (!el) return;
    el.textContent = value || '';
    el.hidden = !value;
  };
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mc-select]');
    if (!select) return;
    const card = select.closest('[data-mc]');
    const data = select.selectedOptions[0]?.dataset;
    if (!card || !data) return;

    const price = card.querySelector('[data-mc-price]');
    if (price) price.textContent = data.price;

    const mrpWrap = card.querySelector('[data-mc-mrp-wrap]');
    const mrp = card.querySelector('[data-mc-mrp]');
    if (mrpWrap && mrp) {
      mrp.textContent = data.mrp || '';
      mrpWrap.hidden = !data.mrp;
    }

    const off = card.querySelector('[data-mc-off]');
    if (off) {
      const pct = Number(data.pct || 0);
      off.textContent = pct > 0 ? `${pct}% OFF` : '';
      off.hidden = pct <= 0;
    }

    setText(card.querySelector('[data-mc-unit]'), data.unit);
    setText(card.querySelector('[data-mc-save]'), data.save);

    const add = card.querySelector('[data-mc-add]');
    if (add) add.disabled = data.available !== 'true';

    const error = card.querySelector('[data-form-error]');
    if (error) error.textContent = '';
  });

  /* Countdown timers */
  document.querySelectorAll('[data-mtimer]').forEach((el) => {
    const end = new Date(el.dataset.end).getTime();
    if (!end || Number.isNaN(end) || end <= Date.now()) return;
    const parts = {
      d: el.querySelector('[data-d]'),
      h: el.querySelector('[data-h]'),
      m: el.querySelector('[data-m]'),
      s: el.querySelector('[data-s]'),
    };
    const pad = (n) => String(n).padStart(2, '0');
    let timer = null;
    const tick = () => {
      let left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      const d = Math.floor(left / 86400);
      left %= 86400;
      const h = Math.floor(left / 3600);
      left %= 3600;
      const m = Math.floor(left / 60);
      const s = left % 60;
      parts.d.textContent = `${d}d`;
      parts.h.textContent = `${pad(h)}h`;
      parts.m.textContent = `${pad(m)}m`;
      parts.s.textContent = `${pad(s)}s`;
    };
    tick();
    el.hidden = false;
    timer = setInterval(tick, 1000);
  });

  /* Tap-to-copy coupon codes */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy]');
    if (!button) return;
    event.preventDefault();
    const status = button.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(button.dataset.copy);
      if (status) {
        status.textContent = button.dataset.copied || 'Copied';
        clearTimeout(button._copyTimer);
        button._copyTimer = setTimeout(() => {
          status.textContent = '';
        }, 2000);
      }
    } catch {
      /* Clipboard blocked: the code stays visible so customers can type it */
    }
  });
})();
